module.exports = __webpack_public_path__ + "static/img/xx_pic3.383354d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rizhi/xx_pic3.jpg
// module id = g44x
// module chunks = 5